<template>
  <posts-toolbar
    :filters="filters"
    :minimized="minimized"
    :maximize-btn="maximizeBtn"
    @update:filters="$emit('update:filters', $event)"
  >
    <select-client
      :account-id="accountId"
      :model-value="clientId"
      style="min-width: 300px;"
      filled
      @update:modelValue="$emit('update:clientId', $event)"
    />
  </posts-toolbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PostsToolbar from '@/social/post/list/ResponsivePostsToolbar.vue';
import SelectClient from '@/client/SelectClient.vue';
import { PostFilters } from '@/type';

export default defineComponent({
  emits: ['update:clientId', 'update:filters'],
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    clientId: Number,
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
    minimized: {
      type: Boolean,
      default: false,
    },
    maximizeBtn: Object,
  },
  components: {
    PostsToolbar,
    SelectClient,
  },
});
</script>
